













































import { Component, Vue, Watch, Prop } from "vue-property-decorator";

import { getLandmarkListByPage } from "@/axios";

@Component({
  name: "landmarkFamily",
})
export default class extends Vue {
  @Prop()
  inputLandmarkFamilyData: any;

  @Watch("inputLandmarkFamilyData", { immediate: true, deep: true })
  oninputLandmarkFamilyData(val: any, oldVal: any) {
    if (val) {
      // this.landmarkArray = val.landmarkArray;
      // this.landmarkCount = val.landmarkCount;
      this.cityList = val.cityList;
      // console.log('this.landmarkFamilyData----------',val)
    }
  }

  private landmarkFamilyData: any = {
    cityList: [],
    landmarkArray: [],
    landmarkCount: 0,
  };

  private landmarkArray: any = [];
  private landmarkCount: any = 0;
  private cityList: any = [];

  private cityIndex: any = 0;
  private page: any = 1;
  private page_size: any = 12;
  private area_id: any = "";
  mounted() {
    this.changeData();
  }
  private changeData() {
    getLandmarkListByPage({
      area_id: this.area_id,
      page: this.page,
      page_size: this.page_size,
    }).then((res: any) => {
      console.log("getLandmarkListByPage--------", res);
      this.landmarkArray = res.data.data.data;
      this.landmarkCount = res.data.data.count;
    });
  }

  private changeCityIndex(index: any, id: any) {
    this.area_id = id;
    this.cityIndex = index;
    this.page = 1;
    this.changeData();
  }

  private goLandmarkIndex(id: any) {
    this.$router.push({
      path: "/landmarkIndex",
      query: { landmarkId: id },
    });
  }

  private pageChange(page: any) {
    // console.log(page)
    this.page = page;
    this.changeData();
  }
}
